export default "<p-toast position=\"bottom-right\" key=\"br\"></p-toast>";